// extracted by mini-css-extract-plugin
module.exports = {"viewButton":"viewButton--1VasG","leftCol":"leftCol--ITuyX"};